import { FC, ReactElement } from "react"

import { useTenantsData } from "../../../hooks/useTenantsData"
import { ArrowIcon } from "../../icons/ArrowIcon"

import { EditorForm } from "./EditorForm"

export const CMSColorEditor: FC = (): ReactElement => {
  const { tenantId, tenants, toggleEditForm } = useTenantsData()
  return (
    <div>
      {tenants.map((tenant) => (
        <div
          key={tenant.id}
          className="
          first:rounded-t-xl border border-b-0 last:border-b-2 last:rounded-b-xl border-gray-200 focus:ring-4
          focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 gap-3
          "
        >
          <h2>
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 hover:bg-gray-100
          dark:hover:bg-gray-800 "
              onClick={() => toggleEditForm(tenant.id)}
            >
              <span>{tenant.id}</span>
              <ArrowIcon rotate={tenant.id === tenantId} />
            </button>
          </h2>
          <div className={tenant.id !== tenantId ? "hidden" : ""}>
            <div className="p-5 border border-b-0 border-gray-200 dark:border-gray-700 border-[rgba(255,255,255,0.1)] bg-[rgba(255,255,255,0.04)] text-white">
              <EditorForm tenant={tenant} />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
